import { persistStore } from "redux-persist";
import createSagaMiddleware from "redux-saga";
import { createBrowserHistory, createMemoryHistory } from "history";
import { createStore, applyMiddleware, compose } from "redux";

import mySaga from "./sagas";
import reducer from "./reducers";

// If we're on Google translate domain, we need to patch the BrowserRouter's links to behave as
// normal HTML anchors instead of using location.pushState. This is because Google translate
// will change the page's domain, and the browser will not allow cross-domain scripted navigation.
// Hence, we will solve this by using createMemoryHistory & by ignoring pushState just for translate.goog domain
export const history =
  typeof window !== 'undefined' && window.location.href.includes('translate.goog')
    ? createMemoryHistory()
    : createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();

const middlewares = [
  sagaMiddleware
];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancers = [composeEnhancers(applyMiddleware(...middlewares))];

export const store = createStore(reducer, compose(...enhancers));
export const persister = persistStore(store);

sagaMiddleware.run(mySaga);

export default store;
